import { Link } from '@postenbring/hedwig-react';
import { GiftIcon, StampSearchIcon, MobileIcon, LocationDotIcon, BoxMagnifyingGlassIcon, HeadsetIcon, BuildingIcon, FileSignatureIcon, GlobeIcon } from '../../shared/icons';

const ServiceIconToIcon = ({ serviceIcon }) => (
    <>
        {serviceIcon === "adresseendringogoppbevaring" && <LocationDotIcon />}
        {serviceIcon === "hentested" && <LocationDotIcon />}
        {serviceIcon === "smarttelefon" && <MobileIcon />}
        {serviceIcon === "frimerkertilsamling" && <StampSearchIcon />}
        {serviceIcon === "jul" && <GiftIcon />}
        {serviceIcon === "sporing" && <BoxMagnifyingGlassIcon />}
        {serviceIcon === "kundeservice" && <HeadsetIcon />}
        {serviceIcon === "leverttilbedrift" && <BuildingIcon />}
        {serviceIcon === "reklamasjon" && <FileSignatureIcon />}
        {serviceIcon === "internasjonalt" && <GlobeIcon />}
    </>
)

export const MenuIconSection = ({ content }) => (
    <ul className="kp-menu-content-icon-links hds-mt-48-64 hds-mb-40-48">
        {content.map(({ title, url, serviceIcon }) => (
            <li key={url}>
                <Link
                    className=""
                    variant="no-underline"
                    icon='leading'
                    href={url}
                >
                    <ServiceIconToIcon serviceIcon={serviceIcon} />
                    {title}
                </Link>
            </li>
        ))}
    </ul>
)
